import React from 'react';
import css from './Button.css';
import { Icon } from 'semantic-ui-react';
import PropTypes from "prop-types";

export default class LevelUpButton extends React.Component {
    constructor(props) {
        super(props);
        this.focus = React.createRef();
    }

    componentDidUpdate() {
        if (this.props.focusRef) this.focus.current.focus();
    }
    
  render() {
    return (
      <div 
      	className={css['button']} 
      	onClick={() => window.location.hash = ""} 
      	aria-label="Return to Service Catalog"
      	role="button" 
        ref={this.focus}
      	tabIndex="0">
        <Icon name='level up' flipped="horizontally" />
      </div>
    );
  }
}

LevelUpButton.propTypes = {
    focusRef: PropTypes.bool
};
